import type {ChatMessage, ImagePart} from '@Components/ai-chat-window/ai-chat-window.types';

export const EMBEDDED_LIGHTBOX_Z_INDEX = 20000;

export interface ImagePartsLightboxProps {
  chatId: string;
  messageId?: string;
  imageParts: ImagePart[];
  isLightboxOpen: boolean;
  currentImageIndex: number | null;
  handleCloseLightbox: VoidFunction;
  handlePreviousImage: VoidFunction;
  handleNextImage: VoidFunction;
  messages: Record<string, ChatMessage>;
  canWrite: boolean;
  onReattach: (part: ImagePart, previewUrl?: string) => void;
}
